var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#2DB0D8",
    fillOpacity: 0.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8787 12.707C26.0503 11.5355 27.9497 11.5355 29.1213 12.7071L31.2929 14.8786C32.4645 16.0502 32.4645 17.9497 31.2929 19.1213L23.7071 26.707C23.5196 26.8946 23.2652 26.9999 23 26.9999H18C17.4477 26.9999 17 26.5522 17 25.9999V20.9999C17 20.7347 17.1054 20.4804 17.2929 20.2928L24.8787 12.707ZM27.7071 14.1213C27.3166 13.7307 26.6834 13.7307 26.2929 14.1213L19 21.4142V24.9999H22.5858L29.8787 17.7071C30.2692 17.3165 30.2692 16.6834 29.8787 16.2928L27.7071 14.1213L28.2283 13.6001L27.7071 14.1213ZM17 13.9999C15.3431 13.9999 14 15.3431 14 16.9999V26.9999C14 28.6568 15.3431 29.9999 17 29.9999H27C28.6569 29.9999 30 28.6568 30 26.9999V23.9999C30 23.4477 30.4477 22.9999 31 22.9999C31.5523 22.9999 32 23.4477 32 23.9999V26.9999C32 29.7614 29.7614 31.9999 27 31.9999H17C14.2386 31.9999 12 29.7614 12 26.9999V16.9999C12 14.2385 14.2386 11.9999 17 11.9999H20C20.5523 11.9999 21 12.4477 21 12.9999C21 13.5522 20.5523 13.9999 20 13.9999H17Z",
    fill: "#2DB0D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.63092ef853d94183dadc6a04e2ee57f7.svg";
export { ForwardRef as ReactComponent };